import { useMediaQuery, useTheme } from '@mui/material';
import { Separator } from 'react-resizable-panels';

import { useFeatureFlags } from 'src/context';

export const ResizeHandle = ({
  className,
  restColorClass,
}: {
  className?: string;
  /**
   * Overrides the resting (non-hover) divider color; hover/drag feedback is
   * left untouched. Defaults to the sidebar/legacy gray.
   */
  restColorClass?: string;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const { EnableNewSidebar } = useFeatureFlags();

  if (isMobile) {
    return null;
  }

  // v4 renamed the state attribute (drag → active) and keeps the handle in a
  // "focus" state after a drag, so focus gets the same feedback color as hover.
  const restBg =
    restColorClass ?? (EnableNewSidebar ? 'bg-gray-100' : 'bg-gray-200');
  const colorClasses = EnableNewSidebar
    ? `${restBg} data-[separator=hover]:bg-gray-400 data-[separator=active]:bg-gray-400 data-[separator=focus]:bg-gray-400`
    : `${restBg} data-[separator=hover]:bg-gray-500 data-[separator=active]:bg-gray-500 data-[separator=focus]:bg-gray-500`;

  // disableDoubleClick keeps v2 behavior: v4 otherwise resets the layout to
  // its default size on double-click.
  return (
    <Separator
      disableDoubleClick
      className={`w-px h-full ${colorClasses} cursor-col-resize ${className ?? ''}`}
    />
  );
};
